export default class smoothScrollManager{
    constructor(ua){

        this.ua = ua;

        this.w = $(window).innerWidth();
        this.h = $(window).innerHeight();

        this.$header = $("#l-header");
        this.$container = $("#l-scroll");
        this.$body = $("#l-scroll-body");
        this.$pager = $("#l-header-navi-list li")

        this.$actBody = $("#l-scroll-body");

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";

        this.inertia = (Useragnt.mobile||Useragnt.tablet)?false:true; /* 慣性スクロールを有効にするか */


        /* 状態監視用のフラグ */
        this.status = {
            comp     : false, /* 慣性スクロールが完了したか */
            update   : { /* updateさている間隔を取得 */
                timer : 0,
                prevTimer : 0,
                flg   : 0
            }
        }

        this.webglStop = false; /* KVが画面外なら止める */

        /* フルスクリーン制御と通常スクロールを切り替える */
        this.controll = {
            type    : "full",
            prevType    : "full",
            current : 0, /* 表示中のセンテンスを取得 */
            prevCurrent : 0,
            MAX     : 0,
            flg     : false, /* スクロールしたタイミングでtrue 、動作が終わるとfalse */
            mvFlg   : false, /* fullの時に使用。スクロールしたタイミングでtrue、アニメーションが終わったらfalse */
            scFlg   : false, /* fullの時に使用。スクロールイベントが終わったかを監視 */
            scTimer   : "",  /* fullの時に使用。スクロールイベントが終わる時間制御用 */
            target  : {
              $base : $(".js__sc-point"),
              $full : $(".js__sc-fsa"),
              $smooth : $(".js__sc-scrollarea"),
            },
            point : [],

            headH : this.$header.innerHeight(),

            /* SP用に用意 */
            spkvFlg : false, /* KVからのアニメーションを実行したか */
            spScFlg : this.ua==="sp" ? true : true, /* SPの際に有効なスクロール制御フラグ。falseの際にはスクロールを許可しない */
            spKvFlg : true, /* KVエリアを表示しているか */
            spActFlg: false, /* actセンテンスの詳細が表示されている状態か */
            spTypeChangeFlg : false,

            /* PC引っ掛かり様 */
            pcExFlg : false,
            pcExTimer:"",
            /* SPバグ対策 */
            spExFlg : false,

        }
        this.controll.MAX = this.controll.target.$base.length-1;


    }
    init(pageID){

        let _this = this;

        this.pageID = pageID;

        /* 初期設定 */
        this.controll.type = this.controll.point[this.controll.current].type;

        if(!this.inertia) $("body").addClass("is-inertia-none");

        $("#l-pagetop").on("click",function(){
            _this.scControll(0);
        });

        $("#l-scrolldown").on("click",function(){
            _this.scControll(_this.controll.current+1);
        });

        this.$pager.on("click",function () {
            let _target = $(this).data("target");

            _this.scControll(_target);

        });

    }
    scControll(target){

        TweenMax.set(window,{scrollTo:this.controll.point[target].start});

        this.dir = this.controll.prevCurrent<target ? "next":"prev";

        // if(this.ua==="sp"&&target===0) this.dir = "next";

        // this.controll.current = target;

        this.controll.current = target;

        this.controll.type = this.controll.point[target].type;
        this.inc = target==1? this.ua==="sp"&&!Useragnt.android ? 1 : this.h-this.controll.headH : this.controll.point[target].start;
        this.nowInc = target==1? this.ua==="sp"&&!Useragnt.android? 1 : this.h-this.controll.headH : this.controll.point[target].start;
        this.controll.prevCurrent = this.controll.current;
        // this.nowInc = this.controll.point[_target].start;

        if(this.ua==="pc") {
            TweenMax.to(this.$body, 1.8,
                {
                    y : -this.nowInc,
                    ease: "Power2.easeOut",
                    onComplete : function () {
                    }
                }
            );
        }else{
            TweenMax.set(window,{scrollTo:this.inc})
        }



    }
    update(inc,dir){ /* updateのタイミングで方向を指定しないならdirは空 */
        let _this = this;

        this.inc = inc;
        this.dir = dir !=="" ? dir : this.dir;
        this.status.comp = false;
        this.status.update.flg = true;
        // this.controll.pcExFlg = false;

        if(this.ua==="pc"||this.ua==="sp"&&this.controll.current==0 ){

            if (this.controll.type === "full"){

                if(this.controll.mvFlg){
                    clearTimeout(_this.controll.scTimer);
                    _this.controll.scTimer = setTimeout(()=> {
                        _this.controll.flg = _this.controll.mvFlg = false;
                        _this.controll.type = _this.controll.point[_this.controll.current].type;
                        /*スクロール位置を表示しているセンテンスに合わせる*/
                        TweenMax.set(window,{scrollTo:_this.dir==="next" ? _this.controll.point[_this.controll.current].start:_this.controll.point[_this.controll.current].end-_this.h-1});
                    },1e2);
                }

                if(this.controll.flg) return;
                if(_this.ua=="sp") _this.controll.spScFlg = false;
                this.controll.flg = this.controll.scFlg = true;
                this.controll.current = this.dir === "next" ?
                    this.controll.current < this.controll.MAX ? this.controll.current+1 : this.controll.MAX
                    : this.controll.current > 0 ? this.controll.current-1 : 0;
                if(_this.ua=="sp"){
                    setTimeout(()=>TweenMax.set(window,{scrollTo:100}),1e2);
                    setTimeout(()=>_this.controll.spScFlg = true,1e3);

                }


            }

        }else{

            if(this.inc==0&&this.dir=="prev"||this.inc==0&&this.prevInc!=0&&this.controll.type=="smooth"){
                this.controll.type  = "full";
                this.controll.current = 0;
                this.controll.spKvFlg = true;
            }else{
                this.controll.type  = "smooth"

                let _startH = Useragnt.android ? this.h*0.5 : Useragnt.tablet? 0 : this.h,
                    _endH = Useragnt.android ? this.h*0.5/1.5 : Useragnt.tablet? this.h/2 : this.h/1.5;

                for(let i=0; this.controll.point.length>i; i++){

                    if(
                        this.controll.point[i].start - _startH <= this.inc &&
                        this.inc < this.controll.point[i].end - _endH &&
                        this.controll.prevCurrent!=i
                    ){
                        this.controll.current = i;
                        break;
                    }
                }


            }
            this.controll.prevCurrent = this.controll.current;
            this.prevInc = this.inc;


        }




    }
    move(fpsRate,actFlg) {

        // let add = (this.inertia) ?0.08:1;
        let add = (this.inertia) ?0.06:1;
        let _this = this;

        if(!this.status.update.flg){
            this.status.update.prevTimer = this.status.update.timer;
            this.status.update.timer += 1;
        }else{
            this.status.update.flg = false;
            this.status.update.timer = 0;
        }

        this.controll.spActFlg = actFlg;

        if(this.ua==="pc"||this.ua==="sp"&&this.controll.current==0 ){

            if(this.controll.type==="full"){
                if(!this.controll.flg||this.controll.mvFlg) return;
                this.controll.mvFlg = true;
                this.nowInc = this.dir==="next" ? this.controll.point[this.controll.current].start:this.controll.point[this.controll.current].end-this.h-1;

                let _delay = this.controll.prevType=="full" ? 0.9 : 1.2;


                if(this.ua==="pc") {
                    TweenMax.to(this.$body, 0.4,
                        {
                            y : -this.nowInc,
                            ease: "Power2.easeOut",
                            delay:_delay,
                            onComplete : function () {
                                setTimeout(()=>_this.controll.mvFlg = false,1e3);
                            }
                        }
                    );

                }else{


                    setTimeout(()=>_this.controll.mvFlg = this.controll.spTypeChangeFlg = this.controll.spKvFlg = false,1e3);
                }

                this.controll.prevType = this.controll.type;

            }else{

                if(
                    this.controll.point[this.controll.current].start-this.h <= this.nowInc &&
                    this.nowInc < this.controll.point[this.controll.current].end-this.h
                ){
                    this.controll.prevType = this.controll.type;
                    this.nowInc +=  add * (this.inc - this.nowInc)*fpsRate;
                    this.trans();
                }else{


                    /* 引っ掛かりをつける */
                    if(this.status.update.prevTimer!=0&&Useragnt.pc&&!this.controll.pcExFlg) {
                        this.controll.pcExTimer = setTimeout(()=>this.controll.pcExFlg = true,1e3);
                        return;
                    }
                    this.status.update.prevTimer = 0;

                    if(
                        this.controll.point[this.controll.current].start-this.h > this.nowInc&&this.dir=="prev" ||
                        this.nowInc > this.controll.point[this.controll.current].end-this.h&&this.dir=="next"
                    ){
                        this.controll.type = "full";
                        this.controll.pcExFlg = false;
                    }else{
                        this.nowInc +=  add * (this.inc - this.nowInc)*fpsRate;
                        // TweenMax.set(window,{scrollTo:this.controll.point[this.controll.current].end-this.h})
                    }

                }

            }

        }else{

            this.nowInc +=  add * (this.inc - this.nowInc)*fpsRate;
            this.trans();


        }

        if(this.controll.current==0){
            if(!this.controll.spExFlg){
                this.controll.spExFlg = true;
                TweenMax.set(this.$body.find(".p-section"),{opacity:0});
            }

        }else{
            if(this.controll.spExFlg){
                this.controll.spExFlg = false;
                TweenMax.set(this.$body.find(".p-section"),{opacity:1});
            }

        }


    }
    trans() {

        if(this.ua=="pc"){
            TweenMax.set(this.$body,{y:-this.nowInc});
        }



        // if(this.h/2<this.nowInc){
        //     this.webglStop = true;
        // }else{
        //     this.webglStop = false;
        // }



        // fixed.check(this.nowInc,this.dir,"");

        /* TOP KVのイラスト（サービス）動作制御 END */

        if(this.nowInc>this.inc-1){
            this.onComplete();
            // this.prevInc = this.nowInc;
        }
    }

    resize (display) {
        this.w = window.innerWidth;
        // this.h = $(window).height();
        this.h = window.innerHeight;

        $("#l-root").css({"height":this.$body.innerHeight()});
        this.controll.headH = this.$header.innerHeight();


        /* スクロールタイプ切り替え */

        let _offset = 0;
        for(let i=0; i<=this.controll.MAX; i++){
                let _$t = this.controll.target.$base.eq(i),
                _th = _$t.innerHeight();


            this.controll.point[i] = {
                // type  : this.ua==="pc" ? _$t.hasClass("js__sc-fsa") ? "full" : "smooth" : i==0||i==2||i==3 ? "full" : "smooth",
                // type  : this.ua==="pc" ? _$t.hasClass("js__sc-fsa") ? "full" : "smooth" :"smooth",
                type  : _$t.hasClass("js__sc-fsa") ? "full" : "smooth",
                start : _offset,
                end   : _offset + _th
            }
            _offset = _offset+_th;

        }

        if(this.controll.type === "full"&&this.ua==="pc") TweenMax.set(this.$body,{y:-this.controll.point[this.controll.current].start});


    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        if(this.status.comp) return;
        this.status.comp = true;
    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}